import _ from 'lodash';
import { isMobile } from 'react-device-detect';

/**
 * @type {Object}
 */
export const CONVERSATION_LIST_MODES = {
  SELECTABLE: 'selectable',
  READABLE: 'readable',
};

/**
 * @type {Number}
 */
export const CONVERSATIONS_DEFAULT_LIMIT = 25;

/**
 * @type {String}
 */
export const PRE_ARRIVAL_NAME = 'Auto Pre-Arrival';

/**
 * @type {Number}
 */
export const ONE_RESERVATION = 1;

/**
 * @type {Number}
 */
export const NUMBER_OF_SHOW_ATTACHMENTS = 6;

/**
 * @type {String}
 */
export const CHECKIN_CHECKOUT_DATE_TIME_FORMAT = 'MMM DD [at] h:mm a';

/**
 * @type {String}
 */
export const CHECKIN_CHECKOUT_DATE_FORMAT = 'MMM DD';

/**
 * @type {Object}
 */
export const MESSENGER_VIEW_MODES = {
  COMPOUND: 'compound',
  SINGLE: 'single',
};

/**
 * @type {Object}
 */
export const MESSAGE_TYPES = {
  PRE_ARRIVAL: 'pre_arrival',
  STAY_SATISFACTION: ' stay_satisfaction',
  CHECKOUT_REMINDER: 'checkout_reminder',
  THANK_YOU: 'thank_you',
  PROPERTY_READY: 'property_ready',
  AWAY: 'away',
};

/**
 * @type {Object}
 */
export const MESSENGER_SIDEBAR_ACTIONS = {
  ARCHIVE: 'archive',
  CANCEL: 'cancel',
  EDIT: 'edit',
  MARK_SPAM: 'markSpam',
  SETTINGS: 'settings',
};

/**
 * @type {Object}
 */
export const MESSENGER_STATUSES = {
  ARCHIVED: 'archived',
  DELETED: 'deleted',
  INBOX: 'inbox',
  OPTOUT: 'opt_out',
  SPAM: 'spam',
};

/**
 * @type {Number}
 */
export const DAYS_IN_MONTH = 30;

/**
 * @type {String}
 */
export const MESSENGER_BASE_PATH = '/messaging';

/**
 * @type {String}
 */
export const MESSENGER_NEW_MESSAGE_ITEM_KEY = 'newMessageItem';

/**
 * @type {String}
 */
export const MESSENGER_NEW_MESSAGE_PATH = 'new';

/**
 * @type {Number}
 */
export const SHORT_MESSAGE_LENGTH = 62;

/**
 * @type {Array.<String>}
 */
export const messengerViewModesArray = _.values(MESSENGER_VIEW_MODES);

/**
 * @type {Array.<String>}
 */
export const conversationListModesArray = _.values(CONVERSATION_LIST_MODES);

/**
 * @type {Array.<String>}
 */
export const messengerSidebarActionsArray = _.values(MESSENGER_SIDEBAR_ACTIONS);

/**
 * @type {String}
 */
export const GUEST_CHECKIN_DAY = 'guest_checkin_day';

/**
 * @type {String}
 */
export const GUEST_CHECKOUT_DAY = 'guest_checkout_day';

/**
 * @type {String}
 */
export const ALL_GUESTS_STAYING = 'all_guests_staying';

/**
 * @type {String}
 */
export const ALL_OWNERS_STAYING = 'all_owners_staying';

/**
 * @type {String}
 */
export const ALL_OWNERS = 'all_owners';

/**
 * @type {Object}
 */
export const GROUP_BULK_MESSAGE_TITLE = {
  [GUEST_CHECKIN_DAY]: isMobile
    ? 'Guests/Owners who are checking in'
    : 'Guests/Owners who are checking in on a day',
  [GUEST_CHECKOUT_DAY]: isMobile
    ? 'Guests/Owners who are checking out'
    : 'Guests/Owners who are checking out on a day',
  [ALL_GUESTS_STAYING]: isMobile
    ? 'Guests currently staying at property'
    : 'All Guests currently staying at property',
  [ALL_OWNERS_STAYING]: isMobile
    ? 'Owners currently staying at their property'
    : 'All Owners currently staying at their property',
  [ALL_OWNERS]: 'All Owners',
};
export const GROUP_BULK_FLYOUT_TITLE = {
  [GUEST_CHECKIN_DAY]: 'Guests/Owners Checking In',
  [GUEST_CHECKOUT_DAY]: 'Guests/Owners Checking Out',
  [ALL_GUESTS_STAYING]: 'Guests at a Property',
  [ALL_OWNERS_STAYING]: 'Owners at their Property',
  [ALL_OWNERS]: 'All Owners',
};

/**
 * @type {Object}
 */
export const GROUPS_BULK_MESSAGE = [
  {
    code: GUEST_CHECKIN_DAY,
    name: GROUP_BULK_MESSAGE_TITLE[GUEST_CHECKIN_DAY],
  },
  {
    code: GUEST_CHECKOUT_DAY,
    name: GROUP_BULK_MESSAGE_TITLE[GUEST_CHECKOUT_DAY],
  },
  {
    code: ALL_GUESTS_STAYING,
    name: GROUP_BULK_MESSAGE_TITLE[ALL_GUESTS_STAYING],
  },
  {
    code: ALL_OWNERS_STAYING,
    name: GROUP_BULK_MESSAGE_TITLE[ALL_OWNERS_STAYING],
  },
  {
    code: ALL_OWNERS,
    name: GROUP_BULK_MESSAGE_TITLE[ALL_OWNERS],
  },
];

/**
 * @type {Object}
 */
export const EMPTY_PHONE_NUMBER_OBJECT = {
  dial_code: '1',
  phone_number: '',
  country_code: 'us',
  type_contact_object: 'mobile',
};

/**
 * @type {Object}
 */
export const CONVERSATIONS_TYPES = {
  ALL: 'all',
  IMPORTANT: 'important',
  INBOX: 'inbox',
};
